import {useHistory} from 'react-router-dom';
import FilterDropDown from 'components/FilterDropDown';
import Styles from '../job-board-list/internal-job-list.module.css';
import JobBoardMenu from 'components/JobboradMenu';
import {useTranslation} from 'react-i18next';
import {CustomSelect} from 'erp-react-components';
import classNames from './applyjob.module.css';
import Dropzone from 'react-dropzone';
import {useContext, useEffect, useMemo, useState} from 'react';
import {Image} from 'react-bootstrap';
import uploadImage from 'images/svg/upload-h.svg';
import Close from 'images/svg/Icon material-close (1).svg';
import {until} from 'helpers/helpers';
import {Controller, useForm} from 'react-hook-form';
import * as yup from 'yup';
import moment from 'moment';
import {yupResolver} from '@hookform/resolvers/yup';
import FormBuilder from 'components/FormBuilder';
import FileUpload from 'components/FormBuilder/file-upload';
import CheckIcon from 'images/check.png';
import FileUploadError from 'components/FormBuilder/fileUploadError';
import toastService from 'components/Toasts/toast-service';
import {useQueryClient} from 'react-query';
import reactQueryKeys from 'helpers/reactQueryKeys';
import JobBoardMenuMobileView from 'components/JobboradMenu/job-board-menu-mobile-view';
import {getAPI, postAPI} from 'data.api';
import {
  employeeApplyJob,
  employeeUpdateResume,
  questionnaireFileUpload,
} from 'api_urls';
import {AuthContext} from 'contexts/auth.context';

const ApplyJob = () => {
  const {t} = useTranslation();
  const history = useHistory();
  const queryClient = useQueryClient();
  const authProvider = useContext(AuthContext);
  const {userDetails, loadUserDetails} = authProvider;
  const [isLoading, setisLoading] = useState(false);
  const [applySuccess, setapplySuccess] = useState(false);
  const [dynamicSections, setDynamicSections] = useState({});
  const [applyJobFormDetails, setapplyJobFormDetails] = useState<any>([]);
  const [resumeuploadFiles, setResumeUploadFiles] = useState([]);
  const historyState = history?.location?.state?.ViewJob || '';
  const [uploadResumeError, setUploadResumeError] = useState(false);
  const [uploadFiles, setUploadFiles] = useState([]);
  const [uploadError, setUploadError] = useState(false);
  const [removeOrSaveAction, setRemoveOrSaveAction] = useState(false);
  const [updateChild, setupdateChild] = useState(false);

  function importHandle(files) {
    setUploadResumeError(false);
    setResumeUploadFiles(files);
  }

  useEffect(() => {
    getApplyJobForm();
  }, []);

  useEffect(() => {
    userSettingDetails(applyJobFormDetails?.sections);
  }, [applyJobFormDetails]);

  async function getApplyJobForm() {
    if (historyState?.position_number) {
      const query = `jobs/${historyState?.position_number}/get-apply-job-form`;
      setisLoading(true);
      const [err, res] = await until(getAPI(query));
      setisLoading(false);
      if (err) {
        setapplyJobFormDetails(null);
        toastService.error({msg: err.message});
        return console.error(err);
      }
      if (res?.success) {
        const sections_ = (res?.data?.employee_settings?.sections || []).filter(
          (s) => {
            return s?.is_active === 1;
          },
        );
        const settings = {...res?.data?.employee_settings, sections: sections_};
        const fileFields = [];
        const checkboxFields = [];
        if (res?.data?.questionnaire_data) {
          const tempArray = [];
          res.data.questionnaire_data.forEach((_q) => {
            if (_q.fieldType == 'file') {
              fileFields.push(_q.id);
            } else if (_q.fieldType == 'checkbox') {
              checkboxFields.push(_q.id);
            }
            const ques = {
              ..._q,
              fieldType: _q.fieldType === 'yes-no' ? 'radio' : _q.fieldType,
              options:
                _q.fieldType === 'yes-no'
                  ? [
                      {id: _q.id + '1', value: '1', label: 'Yes'},
                      {id: _q.id + '2', value: '0', label: 'No'},
                    ]
                  : _q.options.map((o) => ({
                      id: o.id,
                      label: o.option,
                      value: o.option,
                    })),
            };
            const obj1 = {
              answer: ques.answer,
              auto_disqualify: _q.auto_disqualify,
              fieldType: ques.fieldType,
              hiring_request_id: _q.hiring_request_id,
              id: _q.id,
              is_mandatory: _q.is_mandatory,
              options: ques.options,
              question: _q.question,
              name: `${_q.id}_`,
              label: _q.question,
              value: 1,
            };
            tempArray.push(obj1);
          });
          const obj = {
            is_active: 1,
            attributes: tempArray,
            category_name: 'questionnaire_data',
            category_title: 'Questionnaire',
            section_updated_at: '',
          };
          settings.sections.push(obj);
        }
        setapplyJobFormDetails(settings);
      }
    }
  }

  function userSettingDetails(details) {
    const dynamicSections = {};
    (details || [])
      .filter((d) => d.is_active == 1)
      .forEach((v) => {
        dynamicSections[v.category_name] = {};
        const fields = {};
        v.attributes.forEach((m) => {
          if (m.value !== 1) return;
          if (m.fieldType == 'file') return;
          fields[m.name] = m.label;
          if (m?.extra_fields?.length > 0) {
            (m?.extra_fields || [])?.forEach((e) => {
              dynamicSections[v.category_name][e.name] = e.label;
            });
          }
          dynamicSections[v.category_name][m.name] = m.label;
        });
      });
    setDynamicSections(dynamicSections);
  }

  const schema = yup.lazy(() => {
    const validations = {};
    validations['location'] = yup.string().required('Required').nullable();
    for (const i in dynamicSections) {
      validations[i] = yup.object(
        sectionValidations(dynamicSections[i], excludeValidation, t),
      );
    }
    return yup.object(validations);
  });

  function sectionValidations(sectionObject, excludeValidation, t) {
    const sectionRules = {};
    for (const j in sectionObject) {
      if (!excludeValidation?.includes(j)) {
        if (j === 'is_negotiable') {
          sectionRules[j] = yup.boolean();
          sectionRules[j] = yup
            .string()
            .test(
              'date_of_birth',
              t('Please select a valid date (min 18 yrs)'),
              (value) => {
                return moment().diff(moment(value), 'years') >= 18;
              },
            )
            .required(t('Please enter your date of birth'))
            .nullable();
        } else if (j === 'expected_salary') {
          sectionRules[j] = yup
            .string()
            .matches(
              /^(,*[\d]{1,3},*[\d]{2,7})+$/,
              t('Please Enter valid amount'),
            )
            .required(t('Please enter your expected Salary'))
            .max(10, t('Please enter a valid amount'))
            .nullable();
        } else if (j === 'current_salary') {
          sectionRules[j] = yup
            .string()
            .matches(
              /^(,*[\d]{1,3},*[\d]{2,7})+$/,
              t('Please Enter valid amount'),
            )
            .required(t('Please enter your current Salary'))
            .max(10, t('Please enter a valid amount'))
            .nullable();
        } else if (j === 'notice_period') {
          sectionRules[j] = yup
            .number()
            .required(t('Required'))
            .nullable()
            .typeError(t('Please enter a valid number'))
            .when('notice_period_unit', {
              is: 'days',
              then: yup
                .number()
                .min(1, t('Please enter atleast 1'))
                .max(90, t('Max ninety days allowed'))
                .transform((value) =>
                  isNaN(value) ? undefined : Number(value),
                )
                .positive()
                .nullable(),
            })
            .when('notice_period_unit', {
              is: 'months',
              then: yup
                .number()
                .min(1, t('Please enter greater than 0'))
                .max(3, t('Max 3 months allowed'))
                .transform((value) => (!value ? 0 : value)),
            })
            .when('notice_period_unit', {
              is: 'weeks',
              then: yup
                .number()
                .min(1, t('Please enter greater than 0'))
                .max(12, t('Max 12 weeks allowed'))
                .transform((value) => (!value ? 0 : value)),
            });
        } else {
          const dropDown = [];
          (
            (applyJobFormDetails?.sections || []).filter((s) => {
              return s?.is_active === 1;
            }) || []
          ).map((a) => {
            return (a?.attributes || []).forEach((i) => {
              if (i?.fieldType === 'dropdown') {
                dropDown.push(i?.name);
              }
            });
          });
          if (dropDown?.length && dropDown.includes(j)) {
            sectionRules[j] = yup.array().min(1, t('Required')).nullable();
          } else {
            sectionRules[j] = yup.string().required(t('Required')).nullable();
          }
          sectionRules[j] = yup.string().required(t('Required')).nullable();
        }
      }
    }
    return sectionRules;
  }

  const {defaultValues, excludeValidation} = useMemo(() => {
    const defaultValues = {};
    const excludeValidation = [];
    if (!dynamicSections) {
      return {defaultValues, excludeValidation};
    }
    (applyJobFormDetails?.sections || [])
      .filter((c) => c.is_active == 1)
      .map((/** @type {CandidateSettings.Section}*/ k) => {
        defaultValues[k.category_name] = {};
        return (k.attributes || []).map((m) => {
          if (!m.uId) {
            if (m.mandatory && m.mandatory != true) {
              excludeValidation.push(m.name);
            } else if (!m.mandatory && m.is_mandatory !== 1) {
              excludeValidation.push(m.name);
            } else if (m.fieldType === 'switch' || m.fieldType === 'toggle') {
              excludeValidation.push(m.name);
            }
          }
          if (m.uId) {
            if (m.mandatory != true) {
              excludeValidation.push(m.name);
            } else if (m.fieldType === 'switch' || m.fieldType === 'toggle') {
              excludeValidation.push(m.name);
            }
          }
          if (m?.extra_fields?.length) {
            (m?.extra_fields || [])?.forEach((e) => {
              if (m.is_mandatory != 1) {
                excludeValidation.push(e.name);
              } else {
                return (defaultValues[k.category_name][e.name] = '');
              }
            });
          }
          if (m.fieldType === 'switch' || m.fieldType === 'toggle') {
            defaultValues[k.category_name][m.name] = 0;
          } else {
            defaultValues[k.category_name][m.name] = '';
          }
          return m;
        });
      });
    return {defaultValues, excludeValidation};
  }, [dynamicSections]);

  const {
    handleSubmit,
    control,
    trigger,
    getValues,
    formState: {errors},
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      ...defaultValues,
      location:
        historyState?.preferred_branches?.length === 1
          ? historyState?.preferred_branches[0]?.id
          : null,
    },
    resolver: yupResolver(schema),
  });

  async function handleRedirect(type) {
    if (type === 'jobList')
      history.push({
        pathname: `/internal/jobboard`,
      });
    else
      history.push({
        pathname: `/view/application/${historyState?.position_number}`,
        state: {
          ViewJob: historyState,
          postId: historyState?.hiring_request?.position_number,
        },
      });
  }
  async function onSubmit(data) {
    let resume_path = '';
    if (!resumeuploadFiles?.length) {
      return setUploadResumeError(true);
    }
    if (
      (
        (applyJobFormDetails?.sections || []).find((a) => {
          return a?.category_name === 'questionnaire_data';
        })?.attributes || []
      ).filter((a) => {
        return a?.fieldType === 'file' && a?.is_mandatory == 1;
      })?.length !== uploadFiles.length
    ) {
      return setUploadError(true);
    }
    if (resumeuploadFiles?.length) {
      const formData = new FormData();
      formData.append('file_resume', resumeuploadFiles[0]);
      if (historyState?.position_number) {
        formData.append('position_number', historyState?.position_number);
      }
      setisLoading(true);
      const [err, res] = await until(postAPI(formData, employeeUpdateResume));
      setisLoading(false);
      if (err) {
        return toastService.error({msg: err.message});
      }
      if (res?.data) {
        resume_path = res?.data?.resume_path;
      }
    }
    const uploadedFileDetails = [];
    if (uploadFiles && uploadFiles.length > 0) {
      setisLoading(true);
      const [err, res] = await until(
        uploadFiles.map((item) => {
          const formFileUpload = new FormData();
          if (item.files.length) {
            for (let i = 0; i < item.files.length; i++) {
              formFileUpload.append(
                'file_upload[]',
                item.files.length ? item.files[i] : null,
              );
            }
          }
          formFileUpload.append('key', item.qid);
          return postAPI(formFileUpload, questionnaireFileUpload);
        }),
      );
      setisLoading(false);
      if (err) {
        console.error(err);
        return toastService.error({msg: err.message});
      }
      if (res && res.length) {
        res.map((rf, index) => {
          const obj = {question_id: uploadFiles[index].qid, value: rf.data};
          return uploadedFileDetails.push(obj);
        });
      }
      setUploadFiles([]);
    }
    const {firstName, lastName, middleName} = userDetails;
    let inputValues: any = {
      first_name: firstName || '',
      last_name: `${lastName || ''} ${middleName || ''}`,
      position_number: historyState?.position_number,
      preferred_location_id: data.location,
      timezone:
        Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Calcutta'
          ? 'Asia/Kolkata'
          : Intl.DateTimeFormat().resolvedOptions().timeZone,
      resume_path: resume_path,
    };
    if (data) {
      const keys = Object.keys(data);
      (keys || []).forEach((k) => {
        if (k !== 'questionnaire_data') {
          inputValues = {...inputValues, [k]: data[k]};
        } else {
          const questionnaire = [];
          Object.entries(data['questionnaire_data']).forEach(([key, value]) => {
            questionnaire.push({
              question_id: key?.toString()?.replace('_', ''),
              value: value,
            });
          });
          inputValues = {...inputValues, questionnaire_data: questionnaire};
        }
      });
    }
    if (uploadedFileDetails?.length) {
      inputValues = {
        ...inputValues,
        questionnaire_data:
          inputValues.questionnaire_data.concat(uploadedFileDetails),
      };
    }
    (applyJobFormDetails?.sections || [])
      .filter(
        (c) => c.is_active == 1 && c.category_name != 'questionnaire_data',
      )
      .map((k) => {
        return (k.attributes || []).map((m) => {
          if (m.fieldType === 'date' && m.value === 1) {
            inputValues[k.category_name][m.name] = inputValues[k.category_name][
              m.name
            ]
              ? moment(inputValues[k.category_name][m.name]).format(
                  'YYYY-MM-DD',
                )
              : '';
          }
          return m;
        });
      });
    (applyJobFormDetails?.sections || [])
      .filter(
        (c) => c.is_active == 1 && c.category_name == 'questionnaire_data',
      )
      .map((k) => {
        return (k.attributes || []).map((m) => {
          if (m.fieldType === 'date' && m.value === 1) {
            inputValues['questionnaire_data'] = (
              inputValues?.questionnaire_data || []
            ).map((d) => {
              if (
                m.name?.toString()?.replace('_', '') ===
                d.question_id?.toString()?.replace('_', '')
              ) {
                return {
                  ...d,
                  value: moment(d.value).format('YYYY-MM-DD'),
                };
              } else {
                return d;
              }
            });
          }
          return m;
        });
      });
    setisLoading(true);
    const [err, res] = await until(postAPI(inputValues, employeeApplyJob));
    setisLoading(false);
    if (err) {
      toastService.error({msg: err.message});
      return console.error(err);
    }
    if (res) {
      setapplySuccess(true);
      queryClient.invalidateQueries(reactQueryKeys.ALL_APPLIED_LIST);
      return toastService.success({msg: res.message});
    }
  }

  const handleRemoveFiles = (file, id, index, type) => {
    if (type == 'newFile') {
      if (uploadFiles && uploadFiles.length > 0) {
        uploadFiles.forEach((nf) => {
          if (nf.qid == id) {
            nf.files.splice(index, 1);
          }
        });
      }
      setUploadFiles(
        (uploadFiles || []).filter((u) => {
          return u?.files?.length;
        }),
      );
    }
  };

  let branches = [];
  (historyState?.job_posted_to || [] || []).forEach((j) => {
    branches = [...branches, ...j?.branches];
  });
  branches = (branches || []).filter(
    (arr, index, self) => index === self.findIndex((t) => t.id === arr.id),
  );
  return (
    <>
      <div>
        <FilterDropDown
          dropdown={false}
          viewJob={historyState}
          backBtnDisable={applySuccess}
        />
      </div>
      {!applySuccess ? (
        <div className={classNames['internal-job-container']}>
          <div className={Styles['internal-job-sub-container']}>
            <div className={Styles['internal-job-info-container']}>
              <div className={Styles['internal-job-info']}>
                <JobBoardMenu active={'search-job'} />
              </div>
            </div>{' '}
            <div className={Styles['job-board-list-container']}>
              <div className={classNames['apply-job-drop-down']}>
                <label>
                  {t('Apply_Job_Select Job Location')}
                  <span className={classNames['mandatory-color']}>*</span>
                </label>
                <Controller
                  render={({field: {name, value, onChange, onBlur}}) => (
                    <CustomSelect
                      name={name}
                      placeholder={t('Location')}
                      searchOptions={true}
                      multiSelect={false}
                      style={{border: '1px solid #C6C9E1'}}
                      options={
                        (branches || []).map((p) => {
                          return {label: p?.name, value: p?.id};
                        }) || []
                      }
                      value={value}
                      onChange={(currentVal) => {
                        onChange(currentVal);
                      }}
                      onBlur={onBlur}
                    />
                  )}
                  control={control}
                  name={'location'}
                />

                {errors?.location && (
                  <span className="text-danger text-right input-error-msg">
                    {t('Required')}
                  </span>
                )}
              </div>
              <div
                className={`awl-custom-scroll ${classNames['apply-job-dynamic-questions']}`}
              >
                <div className={` ${classNames['apply-job-upload-others']}`}>
                  <div className={classNames['upload-area']}>
                    <div className={classNames['upload-resume-area']}>
                      <label className={classNames['upload-resume-text']}>
                        {t('Upload Resume')}
                        <span className={classNames['mandatory-color']}>*</span>
                      </label>
                      <Dropzone
                        onDrop={importHandle}
                        accept={['.pdf', '.doc', '.docx']}
                        multiple={false}
                      >
                        {({getRootProps, getInputProps, isDragActive}) => (
                          <div
                            className={classNames['dropfile-in-documents']}
                            {...getRootProps()}
                          >
                            <input
                              {...getInputProps()}
                              id="resume_input"
                              onClick={() => {
                                setUploadResumeError(false);
                              }}
                            />
                            <div
                              className={
                                classNames['upload-text'] +
                                ' ' +
                                classNames['parent-color']
                              }
                            >
                              <Image
                                src={uploadImage}
                                className={classNames['upload-img']}
                              />
                              {isDragActive
                                ? t('Apply_Job_Drop it Here!')
                                : t('Apply_Job_Browser or Drop file here')}
                            </div>
                            <div
                              className={
                                classNames['apply-job-upload-format-msg']
                              }
                            >
                              {t('Supporting formats .pdf, .doc, .docx')}
                            </div>
                          </div>
                        )}
                      </Dropzone>
                      {uploadResumeError && (
                        <span className="text-danger text-right input-error-msg">
                          {t('Required')}
                        </span>
                      )}
                    </div>
                    <div className={classNames['resume-file']}>
                      {resumeuploadFiles?.length ? (
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            setResumeUploadFiles([]);
                            (
                              document.getElementById(
                                'resume_input',
                              ) as HTMLInputElement
                            ).value = '';
                          }}
                          className={classNames['uploded-container']}
                        >
                          <span className={classNames['file-name']}>
                            {(resumeuploadFiles || [])
                              .map((f) => f.name)
                              .join(', ')}
                          </span>
                          <Image
                            className={classNames['resume-file-close']}
                            src={Close}
                          />
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                  <div>
                    {(
                      (applyJobFormDetails?.sections || []).filter((c) => {
                        return c?.category_name !== 'questionnaire_data';
                      }) || []
                    ).map((section, sectionIdx) => {
                      return (
                        <div key={section?.category_name}>
                          <div className={classNames['category-name']}>
                            {section?.category_title}
                          </div>
                          <div>
                            {(section.attributes || []).map((field, idx) => {
                              return (
                                <div
                                  key={field?.name}
                                  className={`${
                                    field.fieldType === 'date'
                                      ? classNames['form-builder-w']
                                      : classNames['form-builder-d']
                                  } ${
                                    field.fieldType === 'dropdown'
                                      ? classNames['select-dd-w']
                                      : ''
                                  }`}
                                >
                                  <FormBuilder
                                    field={field}
                                    index={idx}
                                    category_name={section?.category_name}
                                    control={control}
                                    errors={errors}
                                    trigger={trigger}
                                    getValues={getValues}
                                  />
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                {(applyJobFormDetails?.sections || []).find((q) => {
                  return q?.category_name === 'questionnaire_data';
                })?.attributes?.length ? (
                  <div className={` ${classNames['apply-job-upload-others']}`}>
                    <div className={classNames['future-details-b']}>
                      <label className={classNames['upload-resume-text']}>
                        {t('Apply_Job_Further Details')}
                      </label>
                      {(
                        (applyJobFormDetails?.sections || []).filter((q) => {
                          return q?.category_name === 'questionnaire_data';
                        }) || []
                      ).map((section, sectionIdx) => {
                        return (
                          <div key={section?.category_name}>
                            {(section.attributes || []).map((field, idx) => {
                              return (
                                <div
                                  key={field?.name + idx.toString()}
                                  style={
                                    field.fieldType === 'date'
                                      ? {width: '50%'}
                                      : {display: 'flex'}
                                  }
                                >
                                  {field.fieldType == 'file' ? (
                                    <div
                                      className={'awl-form-group w-100'}
                                      key={
                                        section?.category_name ||
                                        uploadFiles?.length
                                      }
                                    >
                                      <FileUpload
                                        field={field}
                                        index={idx}
                                        category_name={section.category_name}
                                        control={control}
                                        errors={errors}
                                        uploadFiles={uploadFiles}
                                        setUploadFiles={setUploadFiles}
                                        setUploadError={setUploadError}
                                        uploadError={uploadError}
                                        handleRemoveFiles={handleRemoveFiles}
                                        removeOrSaveAction={removeOrSaveAction}
                                        setRemoveOrSaveAction={
                                          setRemoveOrSaveAction
                                        }
                                        // disable={
                                        //   candidateDetails?.application?.status
                                        // }
                                        disable={false}
                                        updateChild={updateChild}
                                        setupdateChild={setupdateChild}
                                      />
                                      <div key={uploadFiles?.length}>
                                        {field?.is_mandatory == 1 ? (
                                          <FileUploadError
                                            uploadError={uploadError}
                                            uploadFiles={uploadFiles}
                                            field={field}
                                            updateChild={updateChild}
                                            setupdateChild={setupdateChild}
                                          />
                                        ) : (
                                          <></>
                                        )}
                                      </div>
                                    </div>
                                  ) : (
                                    <div
                                      key={field?.name + idx.toString()}
                                      style={
                                        field.fieldType === 'date'
                                          ? {width: '50%'}
                                          : {display: 'flex', width: '100%'}
                                      }
                                    >
                                      <FormBuilder
                                        field={
                                          field?.fieldType === 'text' ||
                                          field?.fieldType == 'textarea'
                                            ? {...field, answer: null}
                                            : {...field}
                                        }
                                        index={idx}
                                        category_name={section.category_name}
                                        control={control}
                                        errors={errors}
                                        popperPlacement={'right'}
                                        // disable={
                                        //   candidateDetails?.application?.status
                                        // }
                                        /*temp fix as told by backend team */
                                        disable={false}
                                        // trigger={trigger}
                                        // minDate={new Date()}
                                      />
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <></>
                )}
                <div className={classNames['apply-submit-btn']}>
                  <button
                    className={`mr-2 ${classNames['apply-btn']} `}
                    onClick={handleSubmit(onSubmit, (w, e) => {
                      if (!resumeuploadFiles?.length) {
                        setUploadResumeError(true);
                      }
                      if (
                        (
                          (applyJobFormDetails?.sections || []).find((a) => {
                            return a?.category_name === 'questionnaire_data';
                          })?.attributes || []
                        ).filter((a) => {
                          return a?.fieldType === 'file';
                        })?.length !== uploadFiles.length
                      ) {
                        setUploadError(true);
                      }
                      return console.error(w, e);
                    })}
                    disabled={isLoading}
                  >
                    {t('Submit')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={classNames['success-msg']}>
          <div className={classNames['success-msg-card']}>
            <div>
              <img
                className={classNames['check-image-icon']}
                src={CheckIcon}
              ></img>
            </div>
            <div>
              {t('Apply_Job_Your application has been submitted successfully.')}
            </div>
            <div className={classNames['success-msg-btns']}>
              <button
                className={`mr-2 ${classNames['success-view-btn']} `}
                onClick={() => handleRedirect('jobList')}
              >
                {t('Apply_Job_Back to Search Job')}
              </button>
              <button
                className={`${classNames['success-apply-btn']} `}
                onClick={() => handleRedirect('viewApplication')}
              >
                {t('Applications_View Application')}
              </button>
            </div>
          </div>
        </div>
      )}
      {!applySuccess ? (
        <div className={Styles['menu-item-mv']}>
          <JobBoardMenuMobileView active={'search-job'} />
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default ApplyJob;
